import { Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class SafeHtmlService {
  private styleTag = 'style=';
  private itemPropTag = 'itemprop=';
  constructor(private sanitizer: DomSanitizer) {}

  getSafeHtmlWithStyles(content: string): string {
    let stylePropRemoved = _.replace(content, new RegExp(this.styleTag, 'g'), this.itemPropTag);
    let sanitizedContent = this.sanitizer.sanitize(SecurityContext.HTML, stylePropRemoved);
    return _.replace(sanitizedContent, new RegExp(this.itemPropTag, 'g'), this.styleTag);
  }
}
